import React from 'react';
import FileUploadReportForm from '../FileUploadReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const FaceExtractInputComponent = () => (
    <FileUploadReportForm
        banner={{ icon: 'pi-image', title: 'Face Extract', subtitle: 'Extract face features from an uploaded image via Surepass' }}
        fileFields={[
            { name: 'image', label: 'Image', accept: 'image/*', maxSizeBytes: 5 * 1024 * 1024, hint: 'JPG / PNG up to 5 MB', colClass: 'col-12 md:col-8 lg:col-6' },
        ]}
        endpoint={{ path: '/surepass/face/extract' }}
        consentReportType="face-extract"
        submitLabel="Extract Face"
        successSummary="Face extracted"
        errorSummary="Face extraction failed"
        confirmHeader="Confirm face extraction"
        confirmAcceptLabel="Yes, extract"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'Face Extract Result', icon: 'pi-image' }}
    />
);

export default FaceExtractInputComponent;
